import Link from "next/link";

interface BezUtisakaType {
    id: number;
    slug: string;
}

export default function BezPlate({ id, slug }: BezUtisakaType) {
    return (
        <section className="relative">
            <div className="text-center mb-12 px-4 text-gray-dark">
                <p className="leading-6">
                    <strong>
                        Za ovu kompaniju trenutno nema informacije o visini
                        plata. 😔
                    </strong>
                    <br />
                    <span>
                        Ukoliko radiš ovdje ili si radio, anonimno ostavi
                        informaciju o plati.
                    </span>
                    <br />
                </p>
            </div>
        </section>
    );
}
